import "./programaInstitucionalDeDesarrollo.css";
import Card from "../Card/Card";

function ProgramaInstitucionalDeDesarrollo() {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title">PROGRAMA INSTITUCIONAL DE DESARROLLO</h3>
        <hr className="hr-gob" />
      </div>
      <div className="row">
        <Card
          document="Información"
          description="Programa Institucional de Desarrollo"
          title="P.I.D. 2023-2028"
          href="/CAASIM/PID/2023/PID 2023-2028 CAASIM..pdf"
          type={"PDF"}
        />
        <Card
          document="Información"
          description="Programa Institucional de Desarrollo"
          title="P.I.D. 2022"
          href="/CAASIM/PID/2022/PID 2020-2022 CAASIM.pdf"
          type={"PDF"}
        />
      </div>
    </div>
  );
}

export default ProgramaInstitucionalDeDesarrollo;
